import { z } from 'zod';

// The render tool publishes no data for a reference component: the receipt
// names the outreach and the browser reads its candidates itself.
const recommendationsReceiptSchema = z.object({
    render_artifact: z.object({
        component: z.literal('recommendations'),
        outreach_id: z.uuid(),
    }),
});

export function parseRecommendationsReceipt(
    toolName: string | undefined,
    output: unknown,
) {
    if (toolName !== 'render_dynamic_ui') {
        return null;
    }
    const receipt = recommendationsReceiptSchema.safeParse(output);
    return receipt.success
        ? {
              kind: 'recommendations' as const,
              outreachId: receipt.data.render_artifact.outreach_id,
          }
        : null;
}
